module.exports = __webpack_public_path__ + "img/qwello-app-ic-bigger.0ceb7331.svg";